export default "__VITE_ASSET__Bcf9zrcg__"